import ProductListItem from '@anewgo/product-list-item-ng'
import { compose, setDisplayName } from 'react-recompose'

import { requireProps } from '../helper'
import { fromRenderProps, withClient } from '../../hocs'
import { StoreConsumer } from '../../store'
import { pick } from '@anewgo/functions'

const ProductListItemWrapper = compose(
  withClient,
  requireProps({ keys: ['client'] }),
  fromRenderProps(StoreConsumer, pick('uiConfig')),
  setDisplayName('ProductListItemWrapper')
)(ProductListItem)

export default ProductListItemWrapper
